import { Flex } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import NumberInput from "src/components/NumberInput/NumberInput";
import Select, { ISelect } from "src/components/Select";
import Switch from "src/components/Switch/Switch";
import {
  CategoryOptionType,
  useGetCategoryOptionManyLazyQuery,
  useGetLocationTaxRateNamesQuery,
} from "src/generated/graphql";
import { number, object, bool, string, boolean, array } from "yup";
import { useState, useEffect, useContext } from "react";
import { AppContext } from "src/api/AppContext";
import MultiSelect from "src/components/MultiSelect";

export const employeeFormSchema = object().shape({
  cost: number().required("Cost is required"),
  //fee: string().required("Fee is required"),
  isDiscount: bool(),
  revenueCategory: string().required("Revenue category is required"),
  isTaxable: boolean(),
  isPostTax: boolean(),
  taxRates: array(),
});

interface InitialChargeFormFieldsProps<T> {
  form: UseFormReturnType<T>;
  isActive?: boolean;
}

const InitialChargeFormFields = <T,>({
  form,
  isActive = true,
}: InitialChargeFormFieldsProps<T>) => {
  const { currentOrganization, currentLocation } = useContext(AppContext);

  const { data: taxRateNames } = useGetLocationTaxRateNamesQuery({
    variables: { locationId: currentLocation?.id || "" },
    skip: !currentLocation?.id,
  });

  const [getCategories] = useGetCategoryOptionManyLazyQuery({
    onCompleted(data) {
      let _data = data?.categoryOptionMany;
      let _dataRevenue =
        _data
          ?.filter((e) => e.type === CategoryOptionType.Revenue)
          .map((val) => ({
            value: val.id,
            label: val.name,
          })) || [];
      setrevenueArr(_dataRevenue);

      let _dataService =
        _data
          ?.filter((e) => e.type === CategoryOptionType.Fee)
          .map((val) => ({
            value: val.id,
            label: val.name,
          })) || [];
      setfeeeArr(_dataService);
    },
  });
  const [revenueArr, setrevenueArr] = useState<ISelect[]>([]);
  const [feeeArr, setfeeeArr] = useState<ISelect[]>([]);

  useEffect(() => {
    if (currentOrganization?.id) {
      getCategories({
        variables: { orgId: currentOrganization?.id || "" },
      });
    }
  }, [currentOrganization]);

  return (
    <>
      <Flex align="baseline" justify="space-between">
        <Switch
          labelPosition="left"
          label="Taxable"
          checked={form.getInputProps("isTaxable").value}
          {...form.getInputProps("isTaxable")}
        />

        <Switch
          labelPosition="left"
          label="Value is Post-Tax"
          checked={form.getInputProps("isPostTax").value}
          {...form.getInputProps("isPostTax")}
        />
      </Flex>

      <Flex align="baseline" justify="space-between">
        <NumberInput
          w="48%"
          name="cost"
          label="Cost"
          disabled={isActive}
          parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
          formatter={(value) =>
            !Number.isNaN(parseFloat(value as string)) ? `$ ${value}` : "$ "
          }
          precision={2}
          {...form.getInputProps("cost")}
        />
        <Switch
          labelPosition="left"
          disabled={isActive}
          label="Permit Discounts"
          checked={!!form.getInputProps("isDiscountable")?.value}
          {...form.getInputProps("isDiscountable")}
        />
      </Flex>

      <MultiSelect
        data={
          taxRateNames?.locationTaxRateMany?.map((val) => ({
            value: val.id,
            label: val.organizationTaxRate?.name,
          })) || []
        }
        label="Tax Rates"
        {...form.getInputProps("taxRates")}
      />

      <Flex wrap="wrap">
        <Select
          w="100%"
          disabled={isActive}
          data={feeeArr}
          label="Fee Type"
          name="fee"
          {...form.getInputProps("fee")}
        />
        <Select
          withAsterisk
          w="100%"
          disabled={isActive}
          data={revenueArr}
          label="Revenue Category"
          name="revenueCategory"
          {...form.getInputProps("revenueCategory")}
        />
      </Flex>
    </>
  );
};

export default InitialChargeFormFields;
